/* eslint-disable */

import { Modal } from 'antd';
import {
	CloseCircleFilled,
	CheckCircleFilled,
	InfoCircleFilled,
	ExclamationCircleFilled,
} from '@ant-design/icons';

import useModal from '../../hooks/useModal';

import './styles.scss';

function TypeIcon({ type }) {
	const map = {
		error: <CloseCircleFilled className="cm-icon error" />,
		success: <CheckCircleFilled className="cm-icon success" />,
		info: <InfoCircleFilled className="cm-icon info" />,
		warning: <ExclamationCircleFilled className="cm-icon warning" />,
	};
	return map[type] || map.info;
}

const CommonModal = () => {
	const { visible, modalProps, closeModal } = useModal();
	const {
		type,
		title,
		description,
		okText,
		cancelText,
		onOk,
		onCancel,
		closable,
		maskClosable,
	} = modalProps || {};

	const handleOk = async () => {
		if (typeof onOk === 'function') await onOk();
		closeModal();
	};

	const handleCancel = async () => {
		if (typeof onCancel === 'function') await onCancel();
		closeModal();
	};

	return (
		<Modal
			open={visible}
			onOk={handleOk}
			onCancel={handleCancel}
			closable={closable}
			maskClosable={maskClosable}
			footer={null} // custom footer di bawah agar fleksibel
			centered
			width={520}
			zIndex={1100}
			className={`common-modal ${type}`}
		>
			<div className="cm-header">
				<div className={`cm-icon-wrap ${type}`}>
					<TypeIcon type={type} />
				</div>
			</div>

			<h2 className="cm-title">{title}</h2>
			{description ? <p className="cm-desc">{description}</p> : null}

			<div className="cm-actions">
				{cancelText ? (
					<button className="cm-btn ghost" onClick={handleCancel}>
						{cancelText}
					</button>
				) : null}
				<button className="cm-btn primary" onClick={handleOk}>
					{okText || 'OK'}
				</button>
			</div>
		</Modal>
	);
};

export default CommonModal;
